import React from 'react';

const EmptyState = ({
  header = '',
  description = '',
  button = {
    text: '',
    color: 'bg-orange-200',
  },
  onPress,
  src,
  iconSize = 'h-40 w-40',
  isLeftNav = false,
  headerStyle = 'mb-1 font-20',
  descriptionStyle = 'font-16 font-light',
  dark = false,
}) => {
  return (
    <div className='flex flex-col align-center justify-center h-full text-center'>
      {src && <img src={src} className={`${iconSize} mb-5`} style={dark ? { opacity: 0.55, filter: 'brightness(0) invert(1)' } : {}} />}
      <div className={`${headerStyle}`} style={dark ? { color: 'rgba(255,255,255,0.75)' } : {}}>{header}</div>
      <div className={`${descriptionStyle}`} style={dark ? { color: 'rgba(255,255,255,0.35)' } : {}}>{description}</div>
      {onPress && <div className={`${button.color} px-8 py-2 mt-10 rounded-xl text-black shadow hover:opacity-80 cursor-pointer`} onClick={() => onPress()}>
        {button?.text}
      </div>}
    </div>
  );
};

export default EmptyState;
